import { Component, Input, Output, EventEmitter } from '@angular/core'
import { Magazine } from 'src/lib/entity/magazine'
import { ChangePageRequest } from 'src/lib/entity/revenue'

@Component({
  selector: 'maglive-magazine-index',
  templateUrl: './magazine-index.component.html',
  styleUrls: ['./magazine-index.component.scss'],
})
export class MagazineIndexComponent {
  @Input() magazineList: Magazine[]
  @Output() changePageEvent = new EventEmitter<ChangePageRequest>()

  showReveneuIndex(magazineId: number) {
    this.changePageEvent.emit({ name: 'HISTORY_ALL', magazineId: magazineId })
  }
}
